document.addEventListener("DOMContentLoaded", () => {
  var cameraSpecBoxes = document.querySelectorAll(".professional-cameras-spec-box");
  var addToCartWarning = document.querySelector(".professional-cameras-item .product-form__error-message-wrapper")

  cameraSpecBoxes.forEach((cameraSpecBox) => {
    var descendantCamerasSpecAddCopy = cameraSpecBox.querySelector(".professional-cameras-spec-add-copy");

    cameraSpecBox.addEventListener("mouseenter", function () {
      descendantCamerasSpecAddCopy.style.display = "flex";
    });
  
    cameraSpecBox.addEventListener("mouseleave", function () {
      descendantCamerasSpecAddCopy.style.display = "none"; 
    });
  })

  addToCartWarning.addEventListener("click", () => {
    addToCartWarning.style.display = "none"
  })
});
